import { createAction } from '@reduxjs/toolkit';
import {
    eventNormalizer,
    marketsNormalizer,
    selectionsNormalizer,
} from '~shared/utils/dataNormalisers';
import {
    EVENT_ENDED,
} from '~shared/components/sport-event/constants';

export const eventUpdate = createAction('eventUpdate', (data) => {
    const { markets, ...event } = data;

    const normalizedEvent = eventNormalizer(event);
    const { normalizedMarkets, normalizedMarketsEvents } = marketsNormalizer(markets, event.id);
    const { normalizedSelections, selectionsToBeRemoved } = selectionsNormalizer(markets, event.id);

    return {
        payload : {
            event: normalizedEvent,
            markets: normalizedMarkets,
            marketsEvents: normalizedMarketsEvents,
            selections: normalizedSelections,
            selectionsToBeRemoved,
        },
    };
});

export const eventOver = createAction('eventOver', ({ eventId, match_status = EVENT_ENDED}) => {
    return {
        payload: {
            eventId,
            changes: {
                tradable: false,
                active: false,
                match_status,
            },
        },
    };
});
